/* JMB product extras for product sections outside the product page (e.g. home "Featured product").
   Reads the JSON written by snippets/jmb-product-enhance.liquid and, inside that section only:
   - adds the tier look (jmb-tier-scope--<tier>, accent colour),
   - inserts subtitle / tier & line badges / tagline under the title,
   - inserts the Leather / Hardware / Size box under the colour selector,
   - colours the swatches (same rules as the product page: Colour swatch metaobjects,
     colour words in the name, else the colourway photo).
   Mirrors sections/jmb-ui.liquid, which does the same on product pages. */
(function () {
  if (window.__jmbEnhance) return;
  window.__jmbEnhance = true;

  var WORDS = [
    ["dark brown","#4a2f1f"],["havanna","#3e2619"],["bark brown","#4b3020"],["umber","#5a3a24"],["bitter chocolate","#3b2418"],["chocolate","#3f2a1d"],["mocha","#6b4a36"],["pecan","#7a4e2d"],["caramel","#a86b32"],
    ["medium brown","#7b4a2a"],["red brown","#7a3524"],["crazy horse","#6a4528"],["pullup","#6a4528"],["brown","#6b4226"],["bronze","#8a5a2b"],
    ["oxblood","#4e1414"],["burgundy","#5a1a1f"],["sangria","#6e1f2c"],["inferno","#b8321f"],["chili","#9a3a1f"],["rust","#9a4a25"],["red oak","#8a3f25"],["roja","#a12b22"],["red","#a12b22"],
    ["burnt orange","#b8571f"],["orange","#d0702a"],["burnt tan","#9a5a2a"],["otter tan","#9b6a43"],["summer tan","#c08a55"],["vintage tan","#a8713f"],["honey","#b7813f"],["tan","#b07a48"],["natural","#d9b98f"],["vegtan","#d4b088"],["beige","#cdb594"],["taupe","#8c7b6b"],
    ["ivory","#efe6d2"],["old bone","#ddd0b3"],["bone","#ddd0b3"],["cream","#efe4cc"],["white","#f2f0ea"],
    ["yellow","#d9b42b"],["chartreuse","#b7c42a"],["apple green","#7fae3a"],["green apple","#7fae3a"],["camp green","#5b5e36"],["old green","#5e6440"],["moss","#5f6b3a"],["forest","#2f4a32"],["emerald","#1f6b4a"],["dark green","#2f4a32"],["sage","#8c9a7c"],["green","#3f6b3f"],
    ["brilliant tide","#1f8a8a"],["teal","#1f7a7a"],["turquoise","#2aa3a3"],["shark bay","#4f7b86"],["celeste","#7fc6c4"],["sea blue","#2d6f8f"],["bahama","#2d7f9f"],["zaffiro","#1f3f8a"],["midnight blue","#1d2440"],["navy","#1f2a44"],["dark blue","#1f2f52"],["blue","#2f5a8a"],
    ["aubergine","#3f2234"],["purple","#5a2f6b"],["lavender","#a99bc6"],["vinagroon","#4a2a3f"],["desert pink","#d3a39a"],["pink","#d79aa5"],["rose","#b0706a"],
    ["charcoal","#3a3a3a"],["grey","#7d7d7a"],["gray","#7d7d7a"],["silver","#a7a7a4"],["steel","#8a8c8e"],["black","#1c1c1c"]
  ];
  function first(part) {
    var n = " " + part + " ", best = null;
    for (var i = 0; i < WORDS.length; i++) {
      var p = n.indexOf(WORDS[i][0]);
      if (p >= 0 && (!best || WORDS[i][0].length > best[1].length || (WORDS[i][0].length === best[1].length && p < best[0]))) best = [p, WORDS[i][0], WORDS[i][1]];
    }
    return best ? best[2] : null;
  }
  function words(name) {
    var n = name.toLowerCase().split(/\s+[—–-]\s+/)[0];
    n = n.replace(/\bltd\.?\b/g, " ");
    var parts = n.split(/\s*(?:&|\/|\band\b|\bwith\b|\bon\b)\s*/).filter(function (x) { return x.trim(); });
    var out = [], METAL = ["#a7a7a4", "#8a8c8e"];
    parts.forEach(function (p) { var c = first(p); if (c && METAL.indexOf(c) >= 0 && out.length) return; if (c && out.indexOf(c) < 0 && out.length < 2) out.push(c); });
    if (/\b(2[ -]?tone|two[ -]?tone)\b/.test(n) && out.length === 1) return null;
    return out;
  }
  var cache = {};
  function sample(url, cb) {
    if (cache[url] !== undefined) { if (cache[url] && cache[url].then) cache[url].then(cb); else cb(cache[url]); return; }
    var waiters = [cb]; cache[url] = { then: function (f) { waiters.push(f); } };
    var im = new Image(); im.crossOrigin = "anonymous";
    im.onload = function () {
      var res = null;
      try {
        var S = 48, cv = document.createElement("canvas"); cv.width = cv.height = S;
        var cx = cv.getContext("2d"), sw = im.naturalWidth, sh = im.naturalHeight;
        cx.drawImage(im, sw * 0.3, sh * 0.3, sw * 0.4, sh * 0.4, 0, 0, S, S);
        var d = cx.getImageData(0, 0, S, S).data, b = {}, best = null, bestN = 0;
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], bl = d[i + 2], mx = Math.max(r, g, bl), mn = Math.min(r, g, bl);
          if (d[i + 3] < 200) continue;
          if (mn > 205 && mx - mn < 25) continue;
          var k = (r >> 4) + "," + (g >> 4) + "," + (bl >> 4);
          var e = b[k] || (b[k] = [0, 0, 0, 0]); e[0] += r; e[1] += g; e[2] += bl; e[3]++;
          if (e[3] > bestN) { bestN = e[3]; best = e; }
        }
        if (best && bestN > 20) res = "rgb(" + Math.round(best[0] / bestN) + "," + Math.round(best[1] / bestN) + "," + Math.round(best[2] / bestN) + ")";
      } catch (err) { res = null; }
      cache[url] = res; waiters.forEach(function (f) { f(res); });
    };
    im.onerror = function () { cache[url] = null; waiters.forEach(function (f) { f(null); }); };
    im.src = url;
  }
  function paint(el, bg) {
    if (el.getAttribute("data-jmb-sw") === bg) return;
    el.style.setProperty("background", bg, "important");
    el.style.setProperty("background-size", "cover", "important");
    el.setAttribute("data-jmb-sw", bg);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function run(cfg, scopeId) {
    var scope = document.querySelector('[data-section-id="' + scopeId + '"]');
    if (!scope) return;
    if (cfg.tier) {
      scope.classList.add("jmb-tier-scope--" + cfg.tier);
      scope.style.setProperty("--jmb-accent", "var(--jmb-tier-" + cfg.tier + ")");
    }
    // Subtitle / badges / tagline under the title
    if (cfg.head && !scope.querySelector(".jmb-head")) {
      var hl = scope.querySelector(".product__headline");
      if (hl) {
        var wrap = document.createElement("div"); wrap.innerHTML = cfg.head;
        var el = wrap.firstElementChild;
        if (el) {
          hl.appendChild(el);
          var t = hl.querySelector(".product__title"), ta = t ? getComputedStyle(t).textAlign : "left";
          el.style.textAlign = ta;
          var b = el.querySelector(".jmb-badges");
          if (b) b.style.justifyContent = ta === "center" ? "center" : (ta === "right" || ta === "end") ? "flex-end" : "flex-start";
        }
      }
    }
    // Leather / Hardware / Size box
    var specs = scope.querySelector(".jmb-specs");
    if (!specs) {
      var anchor = scope.querySelector(".product__block__variants");
      anchor = anchor && (anchor.closest("[data-morph-root]") || anchor);
      if (anchor) {
        specs = document.createElement("dl");
        specs.className = "jmb-specs"; specs.setAttribute("aria-live", "polite");
        anchor.parentNode.insertBefore(specs, anchor.nextSibling);
      }
    }
    if (specs) {
      var inp = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = (inp && inp.value) ? String(inp.value) : cfg.fallback;
      if (specs.getAttribute("data-for") !== id) {
        var s = (cfg.spec && cfg.spec[id]) || ["", ""], L = cfg.labels, rows = "";
        if (s[0]) rows += '<div class="jmb-specs__row"><dt>' + L.l + '</dt><dd>' + esc(s[0]) + '</dd></div>';
        if (s[1]) rows += '<div class="jmb-specs__row"><dt>' + L.h + '</dt><dd>' + esc(s[1]) + '</dd></div>';
        if (cfg.size) rows += '<div class="jmb-specs__row"><dt>' + L.s + '</dt><dd>' + esc(cfg.size.n) + (cfg.size.d ? '<span class="jmb-specs__fits">' + esc(cfg.size.d) + '</span>' : '') + '</dd></div>';
        specs.innerHTML = rows;
        specs.style.display = rows ? "" : "none";
        specs.setAttribute("data-for", id);
      }
    }
    // Colour swatches
    if (cfg.swatches) {
      scope.querySelectorAll("[data-swatch]").forEach(function (el) {
        if (el.hasAttribute("data-jmb-done")) {
          var want = el.getAttribute("data-jmb-sw");
          if (want && el.style.getPropertyValue("background") === "") { el.removeAttribute("data-jmb-sw"); paint(el, want); }
          return;
        }
        var name = (el.getAttribute("data-swatch") || "").trim();
        if (!name) { var vh = el.querySelector(".visually-hidden"); name = vh ? vh.textContent.trim() : ""; }
        if (!name) return;
        el.setAttribute("data-jmb-done", "");
        var key = name.toLowerCase(), o = cfg.ovr && cfg.ovr[key];
        if (o && o.i) return paint(el, 'center / cover no-repeat url("' + o.i + '")');
        if (o && o.c) return paint(el, o.c2 ? "linear-gradient(135deg," + o.c + " 50%," + o.c2 + " 50%)" : o.c);
        var w = words(name) || [];
        var fb = w.length === 2 ? "linear-gradient(135deg," + w[0] + " 50%," + w[1] + " 50%)" : (w[0] || "");
        if (fb) return paint(el, fb);
        var img = cfg.img && cfg.img[key];
        if (img) sample(img, function (c) { if (c) paint(el, c); });
      });
    }
  }

  var configs = [];
  function load() {
    document.querySelectorAll("script[data-jmb-enhance]").forEach(function (s) {
      if (s.__jmbLoaded) return;
      s.__jmbLoaded = true;
      try { configs.push([JSON.parse(s.textContent), s.getAttribute("data-jmb-enhance")]); } catch (e) {}
    });
  }
  function tick() { load(); configs.forEach(function (c) { run(c[0], c[1]); }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tick); else tick();
  document.addEventListener("change", function () { setTimeout(tick, 60); }, true);
  document.addEventListener("shopify:section:load", tick);
  setInterval(tick, 500);
})();
